import { render } from "./MsBarChart.vue?vue&type=template&id=2db88fa6&scoped=true&ts=true"
import script from "./MsBarChart.vue?vue&type=script&lang=ts"
export * from "./MsBarChart.vue?vue&type=script&lang=ts"

import "./MsBarChart.vue?vue&type=style&index=0&id=2db88fa6&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db88fa6"]])

export default __exports__